import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  users: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/locally/index.js